import React from 'react'

import { TextField } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import parsePhoneNumber from 'libphonenumber-js'
import { get, isEmpty, isUndefined, size, toInteger } from 'lodash'
import PropTypes from 'prop-types'
import ReactPhoneInput from 'react-phone-input-material-ui'

import flags from './flags.png'

const styles = {
  '@global': {
    '.react-tel-input .flag': {
      backgroundImage: `url('${flags}')`,
    },
    '.react-tel-input .flag-dropdown': {
      height: '55px',
    },
    '.react-tel-input .form-control': {
      height: 'auto',
    },
    '.react-tel-input .selected-flag': {
      transform: 'scale(1.5)',
      marginLeft: '13px',
    },
    '.react-tel-input input[type=text], .react-tel-input input[type=tel], .react-tel-input .MuiInputLabel-formControl':
      {
        paddingLeft: '55px',
      },
  },
}

export const getIsValid = (formatted, countryCode) => {
  const fmt = formatted.replace(/[^\d+]/g, '')
  const parsedPhoneNumber = parsePhoneNumber(fmt, countryCode)
  const isValid = isUndefined(parsedPhoneNumber) || parsedPhoneNumber.isValid()
  return isValid && !isEmpty(countryCode)
}

export const getOnChange = (onChange) => {
  return (number, countryCodeData, e, formatted) => {
    const countryCode = get(countryCodeData, 'countryCode', '')
    const dc = get(countryCodeData, 'dialCode', '')
    const dialCode = toInteger(dc) || ''
    const codeRegex = new RegExp(`^${dialCode}`)
    const phone = number.replace(codeRegex, '')
    const isValid = getIsValid(formatted, countryCode)

    onChange(phone, dialCode, isValid)
  }
}
export const getValue = (phone, countryCode) => {
  return size(phone) ? [countryCode, phone].join('') : ''
}

const DEFAULT_COUNTRY = 'us'

export const InternationalPhoneField = ({
  phone,
  countryCode = DEFAULT_COUNTRY,
  inputProps,
  onChange,
  disabled = false,
  ...rest
}) => {
  return (
    <ReactPhoneInput
      disabled={disabled}
      className="react-phone-input-comp"
      country={`${countryCode}`}
      value={getValue(phone, countryCode)}
      onChange={getOnChange(onChange)}
      defaultCountry={DEFAULT_COUNTRY}
      jumpCursorToEnd={false}
      enableLongNumbers
      component={TextField}
      inputProps={{
        autoComplete: 'off',
        fullWidth: true,
        variant: 'outlined',
        ...inputProps,
      }}
      {...rest}
    />
  )
}

InternationalPhoneField.propTypes = {
  phone: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  countryCode: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  inputProps: PropTypes.object,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
}

export default withStyles(styles)(InternationalPhoneField)
